import React, { useState } from "react";
import { toast } from "react-toastify";
import { cancelledCalibrationpi } from "../../../services/CalibrationService";
import { Modal } from "react-bootstrap";

const CancelledCalibration = ({ data, setData }) => {
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [dataInput, setDataInput] = useState({
    status: "cancelled",
    remarks: "",
  });
  const [showModal, setShowModal] = useState(false);
  const [errors, setErrors] = useState({});

  const openModal = () => setShowModal(true);

  const closeModal = () => {
    setDataInput({
      status: "",
      remarks: "",
    });
    setErrors({});
    setShowModal(false);
  };

  const handleResponseChange = (value) => {
    setDataInput({
      ...dataInput,
      status: value,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataInput({
      ...dataInput,
      [name]: value,
    });

    if (name === "remarks" && errors.remarks) {
      setErrors((prevErrors) => ({ ...prevErrors, remarks: "" }));
    }
  };

  const validateForm = () => {
    let formErrors = {};
    if (!dataInput.remarks.trim()) {
      formErrors.remarks = "Remarks is required";
    }
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return; // Stop submission if validation fails
    }
    try {
      setIsSubmitLoading(true);
      const response = await cancelledCalibrationpi(data.id, dataInput);
      setData((prevData) => ({
        ...prevData,
        status: "cancelled",
      }));
      toast.success(response.data.message);
      closeModal();
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
      <button className="btn btn-outline-danger btn-sm mt-3" onClick={openModal}>
        <i className="fa-solid fa-xmark me-2"></i>Cancelled Callibration
      </button>
      <Modal show={showModal} onHide={closeModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Cancelled Callibration</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-4">
            <div className="d-flex align-items-center">
              <div className="form-check me-3">
                <input
                  type="checkbox"
                  id="status"
                  name="status"
                  className="form-check-input"
                  value="cancelled"
                  checked={dataInput?.status === "cancelled"}
                  onChange={(e) => handleResponseChange(e.target.value)}
                />
                <label htmlFor="cancelled" className="form-check-label">
                  Cancelled
                </label>
              </div>
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="remarks" className="form-label">
              Remarks:
            </label>
            <textarea
              id="remarks"
              className="form-control"
              rows="2"
              value={dataInput?.remarks || ""}
              name="remarks"
              onChange={handleChange}
            />
            {errors.remarks && (
              <div className="text-danger mt-1">{errors.remarks}</div>
            )}
          </div>
          <div className="d-flex justify-content-end mt-4">
            <button
              type="button"
              className="btn btn-primary me-3"
              onClick={handleSubmit}
              disabled={isSubmitLoading}
            >
              {isSubmitLoading ? "Submitting..." : "Submit"}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CancelledCalibration;
